import React from 'react';
import ErrorComponent from '../404/404'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // logErrorToMyService(error, errorInfo);
        console.log(error, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            return <ErrorComponent />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;